import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
    { path: ':clientCode/home', component: HomeComponent },
    {
        path: ':clientCode/providers/:providerId/programs/:programIds',
        component: HomeComponent
    },
    {
        path: ':clientCode/providers/:providerId',
        component: HomeComponent
    },
    {
        path: ':clientCode',
        component: HomeComponent,
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: ':clientCode/home',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled' // scrolls to top of page when navigated to it via navigateToUrl
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
